import React, { useState } from 'react';
import Chart from 'react-google-charts';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Heading, RadioButton, Text } from '../../Elements/Elements';
import { options } from './config';
import TrendBlock from './TrendBlock/TrendBlock';
import { monthesPeriods, monthPerLabel } from '../helpers/config/filtersConfig';

import classes from './Column.module.scss';

const Column = ({ chartData }) => {
  const [accountUsagePeriod, setAccountUsagePeriod] = useState('6M');

  const { t } = useTranslation(['activity']);

  const chartArr = [
    [
      t('activity:units.MONTH'),
      t('activity:platform.APPLICATIONS'),
      t('activity:platform.TUNNELS')
    ]
  ];

  let appTrend = 0;
  let tunTrend = 0;
  let appCurrent = 0;
  let tunCurrent = 0;
  let maxChartData = 0;
  const length = chartData ? chartData.length : 0;

  const createData = arr => {
    arr.map(item => {
      maxChartData =
        maxChartData < item.numOfApplications
          ? item.numOfApplications
          : maxChartData;
      maxChartData =
        maxChartData < item.numOfTunnels ? item.numOfTunnels : maxChartData;
      const date = moment(item.cohortMonth).format('MMM');
      chartArr.push([date, item.numOfApplications, item.numOfTunnels]);
      return '';
    });
    if (maxChartData > 9) {
      options.vAxis.maxValue = (maxChartData * 1.2).toFixed(0); //up on 20% if more then 9   // to check!
    }
  };

  if (length !== 0) {
    appCurrent = chartData[length - 1].numOfApplications;
    tunCurrent = chartData[length - 1].numOfTunnels;
    if (length === 1) {
      appTrend = appCurrent;
      tunTrend = tunCurrent;
    } else {
      appTrend = appCurrent - chartData[length - 2].numOfApplications;
      tunTrend = tunCurrent - chartData[length - 2].numOfTunnels;
    }
    switch (accountUsagePeriod) {
      case '1M': {
        if (length < 2) {
          createData(chartData);
        } else {
          const tempArr = chartData.slice(length - 2);
          createData(tempArr);
        }
        break;
      }
      case '3M': {
        if (length < 3) {
          createData(chartData);
        } else {
          const tempArr = chartData.slice(length - 3);
          createData(tempArr);
        }
        break;
      }
      case '6M':
      default: {
        if (length < 6) {
          createData(chartData);
        } else {
          const tempArr = chartData.slice(length - 6);
          createData(tempArr);
        }
        break;
      }
      case '1Y': {
        if (length < 12) {
          createData(chartData);
        } else {
          const tempArr = chartData.slice(length - 12);
          createData(tempArr);
        }
        break;
      }
    }
  } else {
    chartArr.push(['', 0, 0]);
  }

  const handleAccountUsagePeriod = e => {
    if (e.target.value !== accountUsagePeriod) {
      setAccountUsagePeriod(e.target.value);
    }
  };

  const trendData = [
    {
      title: t('activity:platform.APPLICATIONS'),
      curData: appCurrent,
      trendData: appTrend
    },
    {
      title: t('activity:platform.TUNNELS'),
      curData: tunCurrent,
      trendData: tunTrend
    }
  ];

  return (
    <section className={classes.box}>
      <Heading>{t('activity:customers.ACCOUNT_USAGE')}</Heading>
      <div className={classes.info}>
        <TrendBlock trendData={trendData} />
        <RadioButton
          handleUnit={handleAccountUsagePeriod}
          unit={accountUsagePeriod}
          units={monthesPeriods}
          name={t('activity:units.PERIOD')}
          type="c"
          unitsLabel={monthPerLabel}
        />
      </div>
      <Chart chartType="ColumnChart" options={options} data={chartArr} />
      <div className={classes.legend}>
        <Text className={classes.legend_app}>
          {t('activity:platform.APPLICATIONS')}
        </Text>
        <Text className={classes.legend_tun}>
          {t('activity:platform.TUNNELS')}
        </Text>
      </div>
    </section>
  );
};

Column.propTypes = {
  chartData: PropTypes.array
};

export default Column;
